import { render } from "./UserList.vue?vue&type=template&id=022a333e&scoped=true"
import script from "./UserList.ts?vue&type=script&lang=js&external"
export * from "./UserList.ts?vue&type=script&lang=js&external"

import "./UserList.scss?vue&type=style&index=0&id=022a333e&lang=scss&scoped=true&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-022a333e"]])

export default __exports__